import { Text } from '@latitude/text';
import { cn } from '@latitude/token-utils';
import type { HTMLAttributes } from 'react';

/**
 * Represents a description for a form.
 *
 * @component
 * @example
 * ```tsx
 * <FieldDescription>This is a description for the form.</FieldDescription>
 * ```FieldDescription
 */
export const FieldDescription = ({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <Text
      variant="captionMedium"
      className={cn(
        [
          'text-color-comp-form-label-subtext',
          'leading-font-comp-form-sub-text-line-height',
        ],
        className,
      )}
      {...props}
      color="muted"
    />
  );
};
